import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js'
import { format } from 'date-fns'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const ProfitLossResult = ({ result }) => {
  if (!result) return null

  const data = result
  const formattedDate = format(new Date(data.timestamp), 'PPpp')

  const chartData = {
    labels: ['Gross Profit', 'Net Profit'],
    datasets: [
      {
        label: 'Profit ($)',
        data: [data.gross_profit, data.net_profit],
        backgroundColor: ['#16a34a', '#2563eb'],
        borderRadius: 8,
        barThickness: 30,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { callbacks: {
        label: ctx => `$${ctx.raw.toFixed(4)}`
      }}
    },
    scales: {
      y: {
        ticks: {
          callback: value => `$${value}`,
          color: '#fff'
        },
        grid: { color: 'rgba(255,255,255,0.1)' }
      },
      x: {
        ticks: { color: '#fff' },
        grid: { display: false }
      }
    }
  }

  return (
    <div className="rounded-2xl p-6 shadow-xl  bg-slate-800/50  text-white backdrop-blur-lg border border-white/10">
      <h2 className="text-2xl font-bold mb-4">Profit & Loss Result</h2>
      <p className="text-sm text-gray-300 mb-6">Data reflects the most recent update as of:: {formattedDate}</p>


      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div>
          <p className="text-sm text-gray-400">Exchange</p>
          <p className="font-semibold">{data.exchange}</p>
        </div>
        <div>
          <p className="text-sm text-gray-400">Symbol</p>
          <p className="font-semibold">{data.symbol}/{data.quote_currency}</p>
        </div>
        <div>
          <p className="text-sm text-gray-400">Investment</p>
          <p className="font-semibold">${data.investment_usd}</p>
        </div>
        <div>
          <p className="text-sm text-gray-400">Buy Price</p>
          <p className="font-semibold">${data.buy_price}</p>
        </div>
        <div>
          <p className="text-sm text-gray-400">Sell Price</p>
          <p className="font-semibold">${data.sell_price}</p>
        </div>
        <div>
          <p className="text-sm text-gray-400">Quantity</p>
          <p className="font-semibold">{data.quantity}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-zinc-800/50 p-4 rounded-xl">
          <p className="text-sm text-gray-400">Gross Profit</p>
          <p className="text-lg font-bold text-green-400">${data.gross_profit} ({data.gross_profit_pct}%)</p>
        </div>
        <div className="bg-zinc-800/50 p-4 rounded-xl">
          <p className="text-sm text-gray-400">Net Profit</p>
          <p className="text-lg font-bold text-blue-400">${data.net_profit} ({data.net_profit_pct}%)</p>
        </div>
      </div>

      <div className="bg-zinc-800/50 p-4 rounded-xl mb-6">
        <p className="text-sm text-gray-400">Total Fees</p>
        <p className="text-lg font-bold text-yellow-300">${data.total_fees}</p>
      </div>

      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Profit Overview</h3>
        <Bar data={chartData} options={chartOptions} />
      </div>
      <p className="text-xs text-gray-300 mb-6">This is tentative data and may not reflect precise values. </p>

    </div>
  )
}

export default ProfitLossResult
